import StatusBadge, { StatusTone } from "@buildpy/ui/status-badge";
import { QUOTE_STATUS_LABEL, QuoteStatus } from "@buildpy/core/modules/quote/types";

// 상태 → 톤. 톤표는 components/status-badge 와 디자인 시스템 StatusBadge 표를 따른다.
export const QUOTE_STATUS_TONE: Record<QuoteStatus, StatusTone> = {
  DRAFT: "hold",
  SENT: "new",
  NEGOTIATING: "progress",
  WON: "done",
  LOST: "dropped",
};

interface Props {
  status: QuoteStatus;
  className?: string;
}

const QuoteStatusBadge = ({ status, className }: Props) => (
  <StatusBadge className={className} label={QUOTE_STATUS_LABEL[status]} tone={QUOTE_STATUS_TONE[status]} />
);

export default QuoteStatusBadge;
